import * as React from "react";

export interface IPageWrapperProps {}

export function PageWrapper(props: React.PropsWithChildren<IPageWrapperProps>) {
  // Dev mode is shown by the DevToolbar (RootWrapper), not a banner here.
  return <>{props.children}</>;
}
